// because we can't use 'text' conflicts with base blocks
let VIEW_NAME = {
  date: 'DateInput',
  text: 'TextInput',
  phone: 'PhoneInput',
  number: 'NumberInput',
  email: 'EmailInput',
  boolean: 'BooleanInput',
  address: 'AddressInput',
  contact: 'ContactInput',
  multiplechoice: 'MultipleChoice',
  choice: 'Choice',
}

export function getView(value) {
  return VIEW_NAME[value] ?? value
}
